import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({name: "", email: "", password: "", role: "employee" });

  const handleRegister = async () => {
    try{
      await API.post("/auth/register", form);
      alert("Registered");
      navigate("/");
    } 
    catch(err){
      alert(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md space-y-4">
        <div className="bg-white p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-bold mb-6">Staff Registration</h2>
          <input className="w-full border p-3 rounded mb-4" placeholder="Full Name" onChange={e => setForm({...form, name: e.target.value})} />
          <input className="w-full border p-3 rounded mb-4" placeholder="Email" onChange={e => setForm({...form, email: e.target.value})} />
          <input className="w-full border p-3 rounded mb-4" type="password" placeholder="Password" onChange={e => setForm({...form, password: e.target.value})} />
          <select className="w-full border p-3 rounded mb-4" onChange={e => setForm({...form, role: e.target.value})}>
            <option value="employee">Employee</option>
            <option value="security">Security Desk</option>
            <option value="admin">Admin</option>
          </select>
          <button onClick={handleRegister} className="w-full bg-green-600 text-white p-3 rounded font-bold">Register</button>
        </div>

        <button onClick={() => navigate("/")} className="text-gray-500 font-medium hover:text-blue-600 transition underline">
          Back to Staff Login
        </button>
      </div>
    </div>
  );
}
export default Register;
